
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[shortCode]",
      function () {
        return require("private-next-pages/c/[shortCode]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[shortCode]"])
      });
    }
  